import { createThunk } from 'utils/createThunk';
import * as backendAPI from 'api/backendAPI/models';
import types from 'constants/actionTypes';

export const fetchModelPipeline = createThunk({
  apiCall: backendAPI.getModelPipeline,
  type: types.GET_MODEL_PIPELINE_REQUEST,
});

export const updateSelectedChart = data => ({
  type: types.UPDATE_SELECTED_CHART,
  payload: data,
});
